import React from 'react';
import { buildKeyedPathResolver, ObjectPathFieldGroup } from '@features/onboarding/utils/pathResolver';
import { InsurancePlan } from 'src/services/interfaces/insurance';
import { formatIncome } from '@utils/index';
import { CATEGORY_FIELD_GROUPS } from './constants/plans';

interface PlanDetailsProps {
  plan: InsurancePlan;
}
interface Doc {
  path: string;
  fileName: string;
  displayName: string;
}

// TODO need refactoring e.t.c
export const FormPlanDetails: React.FC<PlanDetailsProps> = ({ plan }) => {
  const resolve = buildKeyedPathResolver(plan);

  // Get field groups for this plan category
  const effectiveGroups = CATEGORY_FIELD_GROUPS[plan.category] ?? [];

  const isNumericNonZero = (value: string | number) =>
    /^[0-9]+(\.[0-9]+)?$/.test(`${value}`) &&
    parseFloat(`${value}`) !== 0;

  const displayValue = (val: string | number) => isNumericNonZero(val) ? formatIncome(+val) : val;

  return (
    <div className="space-y-4 text-[12px]">
      {plan.longDescription && (
        <p className="text-sm mb-4">{plan.longDescription}</p>
      )}

      {effectiveGroups.map((group: ObjectPathFieldGroup) => (
        <div key={group.title}>
          <h4 className="font-bold mb-1 text-black text-[15px]">{group.title}</h4>
          <div className="rounded-lg divide-y divide-gray-200">
            {group.items.map((item, idx) => {
              const { value, keyUsed } = resolve(item);
              return (
                <div key={idx} className="flex justify-between py-1 bg-white text-black">
                  <span className="font-medium min-w-1/3">{item.label}</span>
                  <span className="pl-3  font-semibold text-right min-w-1/3">{displayValue(value)}</span>
                  {/* Debug info (можно удалить или закомментировать) */}
                  {/* <span className="text-xs text-gray-400 ml-2">({keyUsed})</span> */}
                </div>
              );
            })}
          </div>
        </div>
      ))}

      {Array.isArray(plan.documents) && plan.documents.length > 0 && (
        <div className="mt-4 space-y-1">
          <h4 className="font-bold text-black mb-1 text-[15px]">Additional Docs</h4>
          <div className="flex gap-3 flex-wrap mb-3">
            {plan.documents.map((doc: Doc, idx: number) => (
              <a
                key={idx}
                href={`${import.meta.env.VITE_APP_BASE_URL}${doc.path.slice(1)}/${doc.fileName}`}
                target="_blank"
                rel="noopener noreferrer"
                className=" text-[10px] bg-[#fae5e9] p-2 rounded-[6px] w-fit font-medium text-primary h-fit"
              >
                {doc.displayName || doc.fileName}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
